/* eslint-disable */

import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import RaindropTabBar from "../../../ui-components/tab-bar/raindrop-tab-bar.tsx";
import RaindropTopBar from "../../../ui-components/raindrop-top-bar/raindrop-top-bar.tsx";
import { Orientation, Size } from "../../../logic/enums.ts";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import RaindropSideBar from "../../../ui-components/side-bar/raindrop-side-bar.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";
import AccountAvatar from "../../../ui-components/account-avatar/account-avatar.tsx";
import StreakDisplay from "../../../ui-components/streak-display/streak-display.tsx";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import {
  isLocalEnvironment,
  isProductionEnvironment,
} from "../../../services/environment.js";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";

import RaindropCard, {
  RaindropCardStyle,
} from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import { useScroll } from "framer-motion";
import RaindropAccount from "../raindrop-account/raindrop-account.tsx";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";
import RaindropCardWarning from "../../../ui-components/raindrop-card-warning/raindrop-card-warning.tsx";

const ShareComponent = ({ namePreferred, username, values }) => {
  return (
    <div className="flex flex-col gap-4 w-[300px] bg-color-dark-background-secondary rounded-lg p-4 border-b-4 border-b-color-raindrop-primary">
      {/* Main Square */}
      <div className="w-full bg-color-dark-background-primary  aspect-square rounded-lg border-4 relative">
        <div className="filter  scale-100">
          <RaindropCircle
            sausageValues={values}
            size="SMALL"
            isUsingLayout={false}
          />
        </div>
      </div>

      {/* Names */}
      <div className="flex flex-col h-full w-full items-start gap-4">
        <div className="flex flex-col">
          <h1 className="font-bold text-xl text-color-dark-text-primary">
            {namePreferred}
          </h1>
          <h1 className="font-semibold text-color-dark-text-secondary">
            {username}
          </h1>
        </div>
      </div>

      {/* Raindrop Title */}

      <RaindropTitle size={Size.Small} isPrimary={true} />
    </div>
  );
};

const RightHandPanelTopBar = ({ userCurrent }) => {
  const navigate = useNavigate();

  if (!userCurrent) {
    return null;
  }

  let streak = userCurrent?.account?.streak?.currentStreak;

  return (
    <div className="flex flex-row w-full items-center justify-between px-6">
      <RaindropClickable
        onClick={() => {
          navigate(`/raindrop/account/${userCurrent?.account?.id}`);
        }}
      >
        <div className="flex flex-row gap-4 items-center justify-center ">
          <AccountAvatar presignedUrl={userCurrent.account.presignedUrl} />
          <div className="flex flex-col text-right">
            <RaindropTextHeading1>
              {userCurrent?.namePreferred}
            </RaindropTextHeading1>
            <RaindropTextSubtitle>
              {userCurrent?.account?.username}
            </RaindropTextSubtitle>
          </div>
        </div>
      </RaindropClickable>
      <StreakDisplay streak={streak} />
    </div>
  );
};

const RaindropFunFact = () => {
  // Feature gate
  if (isProductionEnvironment()) {
    return null;
  }
  if (isLocalEnvironment()) {
    return null;
  }
  return (
    <div className="flex flex-col py-6 opacity-40 h-full items-center justify-center">
      <RaindropTextHeading1>
        <div className="flex flex-row gap-2 items-center">
          <i className="fa-solid fa-lightbulb " />
          Good to know
        </div>
      </RaindropTextHeading1>

      <RaindropTextParagraph>
        <div className="w-full text-left ">
          <div>
            <span className="font-bold">8,000 people died</span> from terrorist
            attacks last year
          </div>
          <div>
            <span className="font-bold">18,000,000 people died</span> from heart
            attacks last year
          </div>
          <div className="text-xs">Source • UNHCR</div>
        </div>
      </RaindropTextParagraph>
    </div>
  );
};

const RaindropFullScreenRightHandlePanel = ({
  values,
  setShareComponent,
  userCurrent,
}) => {
  const navigate = useNavigate();

  const isRaindropPlus = userCurrent?.account?.isRaindropPlus;
  const isPaused = userCurrent?.account?.accountPlan?.isPaused;

  return (
    <div className="flex flex-col w-full h-full items-center py-8 px-4">
      <RightHandPanelTopBar userCurrent={userCurrent} />

      <div className="flex flex-col h-full items-center justify-center gap-2 ">
        <RaindropCircle
          sausageValues={values}
          isUsingLayout={false}
          isSpringyTransition={false}
          id="raindrop-circle-full-screen"
          onClick={() => {
            navigate("/raindrop/contribution");
          }}
          isRaindropPlus={isRaindropPlus}
          isPaused={isPaused}
          accountAwardFeaturedSlug={
            userCurrent?.account?.accountAwardFeatured?.award?.slug
          }
        />

        <RaindropButton
          title="Share"
          size={Size.Large}
          style={ButtonStyle.Secondary}
          icon="fa-fire"
          onClick={() =>
            setShareComponent(
              <ShareComponent
                values={values}
                namePreferred={userCurrent?.namePreferred}
                username={userCurrent?.account?.username}
              />
            )
          }
        />
      </div>
      <RaindropFunFact />
      <div className="flex flex-col items-end">
        <div className="flex flex-row uppercase flex-wrap items-center justify-center font-black text-sm text-color-dark-text-tertiary opacity-40 w-full max-w-xs pb-6">
          <RaindropButton
            style={ButtonStyle.Tertiary}
            title="Tour"
            to={`/raindrop/tour`}
          />
          <RaindropButton
            style={ButtonStyle.Tertiary}
            title="About"
            to={"https://www.theraindropcompany.com/stratus/about-us"}
          />

          <RaindropButton
            style={ButtonStyle.Tertiary}
            title="Blog"
            to={"https://www.theraindropcompany.com/stratus/blog"}
          />
          <RaindropButton style={ButtonStyle.Tertiary} title="Careers" />

          <RaindropButton
            style={ButtonStyle.Tertiary}
            title="Terms"
            to="https://www.theraindropcompany.com/stratus/terms-and-conditions"
          />
          <RaindropButton
            style={ButtonStyle.Tertiary}
            title="Privacy"
            to="https://www.theraindropcompany.com/stratus/privacy-policy"
          />
        </div>
      </div>
    </div>
  );
};

const NoInternetConnection = ({ isConnectedToInternet }) => {
  const [isDismissed, setIsDismised] = useState(false);
  if (isConnectedToInternet) {
    return null;
  }

  if (isDismissed) {
    return null;
  }
  return (
    <RaindropCardWarning
      title={"Lost internet connection"}
      body={
        "Oh no! The internet connection has been lost. You may experience the app behaving a little funny, but hopefully we'll be back online soon."
      }
    />
  );
};

const RaindropBaseTabBar = ({
  userCurrent,
  onResetCircle,
  orientation,
  values,
  setShareComponent,
  isFocusedOnCenter = false,
  isRaindropPlus = false,
}) => {
  const [isConnectedToInternet, setIsConnectedToInternet] = React.useState(
    navigator.onLine
  );

  const sideOpacity = isFocusedOnCenter ? "opacity-20" : "opacity-100";

  let streak = userCurrent?.account?.streak?.currentStreak;

  // Check internet connection
  useEffect(() => {
    window.addEventListener("online", () => setIsConnectedToInternet(true));
    window.addEventListener("offline", () => setIsConnectedToInternet(false));
  }, []);

  if (orientation === Orientation.Landscape) {
    return (
      <div className="flex h-full w-full ">
        <div
          className={`w-full max-w-[300px] h-full ${sideOpacity} transition-all`}
        >
          <RaindropSideBar
            userCurrent={userCurrent}
            onResetCircle={onResetCircle}
            isRaindropPlus={isRaindropPlus}
          />
        </div>
        <div className="flex  justify-center w-full h-full  ">
          <div className="flex flex-col h-full w-full max-w-[600px]">
            <NoInternetConnection
              isConnectedToInternet={isConnectedToInternet}
            />
            <Outlet />
          </div>
        </div>
        <div
          className={`hidden xl:flex flex-col h-full items-center justify-center w-[1000px] ${sideOpacity} transition-all`}
        >
          <RaindropFullScreenRightHandlePanel
            values={values}
            userCurrent={userCurrent}
            setShareComponent={setShareComponent}
            isRaindropPlus={isRaindropPlus}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full ">
      <RaindropTopBar streak={streak} />
      <div className="flex flex-col h-full overflow-hidden">
        <NoInternetConnection isConnectedToInternet={isConnectedToInternet} />
        <Outlet />
      </div>
      <RaindropTabBar userCurrent={userCurrent} onResetCircle={onResetCircle} />
    </div>
  );
};

export default RaindropBaseTabBar;
